module.exports = __webpack_public_path__ + "img/图层 6.f03c763c.png";